import React from 'react';
import { Chip } from '@mui/material';
import { withStyles } from '@mui/styles';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { COLORS } from '../../../utils/Application_Constants';
import { assignmentStatusMap } from '../../../utils/Privileging_Mapper';

const styles = {
    statusChipDatePending: {
        border: `1px solid ${COLORS.LT_SUNFLOWER125}`,
        backgroundColor: COLORS.LT_SUNFLOWER10,
        color: COLORS.LT_SUNFLOWER125,
        height: 24,
        opacity: 1,
        borderRadius: '8px',
        borderWidth: '1px',
    },
    statusChipUpcoming: {
        border: `1px solid ${COLORS.LT_JOURNEY}`,
        backgroundColor: COLORS.LT_JOURNEY10,
        color: COLORS.LT_JOURNEY,
        height: 24,
        opacity: 1,
        borderRadius: '8px',
        borderWidth: '1px',
    },
    marginWrapper: {
        marginRight: '10px',
        marginBottom: '10px',
    },
};

const UpcomingAssignmentStatusChip = ({ assignment, classes, t }) => {
    if (!assignment) {
        return null;
    }

    const statusLabel = t(assignmentStatusMap.get(assignment.status));
    if (!statusLabel) {
        return null;
    }

    const chipClass =
        assignment.status === 'Pre-Booked'
            ? classes.statusChipDatePending
            : classes.statusChipUpcoming;

    return (
        <div className={classes.marginWrapper}>
            <Chip classes={{ root: chipClass }} label={statusLabel} />
        </div>
    );
};

UpcomingAssignmentStatusChip.propTypes = {
    assignment: PropTypes.shape({
        status: PropTypes.string,
    }),
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
};

UpcomingAssignmentStatusChip.defaultProps = {
    assignment: null,
};

export default withTranslation()(withStyles(styles)(UpcomingAssignmentStatusChip));
